import React from "react";
import { EmptyList, Loading } from "../../../components";
import { useFavorites } from "../hooks";
import {
  Heart,
  ExternalLink,
  Euro,
  Package as PackageIcon,
} from "lucide-react";
import { Card } from "../../../components/cards";
import { FavoriteButton } from "../components";

export const Favorites = () => {
  const { data, loading, error } = useFavorites();
  console.log("Favorites error:", error);
  console.log("Favorites data:", data);

  if (loading) return <Loading />;

  if (error) {
    return (
      <div className="main-container">
        <div className="text-center py-12">
          <p className="text-red-600">Erreur lors du chargement des favoris</p>
        </div>
      </div>
    );
  }

  if (data?.favorites?.results?.length === 0) {
    return (
      <div className="main-container">
        <div className="mb-6">
          <h1 className="text-2xl font-bold text-gray-900 mb-2 flex items-center gap-2">
            <Heart size={28} className="text-red-600" />
            Mes Favoris
          </h1>
          <p className="text-sm text-gray-600">
            Vos produits favoris pour un accès rapide
          </p>
        </div>
        <EmptyList text="Vous n'avez pas encore de produits favoris" />
      </div>
    );
  }

  return (
    <div className="main-container">
      <div className="mb-6">
        <h1 className="text-2xl font-bold text-gray-900 mb-2 flex items-center gap-2">
          <Heart size={28} className="text-red-600" fill="currentColor" />
          Mes Favoris
        </h1>
        <p className="text-sm text-gray-600">
          {data?.favorites?.results?.length} produit
          {data?.favorites?.results?.length &&
          data?.favorites?.results?.length > 1
            ? "s"
            : ""}{" "}
          en favoris
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
        {data?.favorites?.results?.map((favorite: any) => {
          const product = favorite.product;
          if (!product) return null;

          return (
            <Card key={favorite.id} hover padding="md" className="relative">
              <div className="absolute top-3 right-3 z-10">
                <FavoriteButton productId={product.id} size={20} />
              </div>

              <a href={`/product/${product.id}`} className="block group">
                {/* Image */}
                <div className="aspect-square mb-3 overflow-hidden rounded-lg bg-gray-100 flex items-center justify-center">
                  {product.imgUrl ? (
                    <img
                      src={product.imgUrl}
                      alt={product.name}
                      className="w-full h-full object-cover group-hover:scale-105 transition-transform"
                    />
                  ) : (
                    <PackageIcon size={48} className="text-gray-300" />
                  )}
                </div>

                {/* Info */}
                <div className="space-y-2">
                  <h3 className="font-medium text-gray-900 text-sm line-clamp-2 group-hover:text-primary-600 transition-colors">
                    {product.name}
                  </h3>

                  {product.site && (
                    <p className="text-xs text-gray-500 flex items-center gap-1">
                      <ExternalLink size={12} />
                      {product.site.name}
                    </p>
                  )}

                  <div className="flex items-center justify-between pt-2 border-t border-gray-100">
                    <div className="flex items-center gap-1 text-blue-600 font-semibold">
                      <Euro size={14} />
                      <span>{product.lastPrice.toFixed(2)}</span>
                    </div>

                    {!product.priceOnly && (
                      <div className="text-xs text-gray-500">
                        Stock: {product.lastQuantity}
                      </div>
                    )}

                    {product.priceOnly && (
                      <div className="text-xs text-orange-600 font-medium">
                        Prix only
                      </div>
                    )}
                  </div>

                  {product.reference && (
                    <p className="text-xs text-gray-400 truncate">
                      Réf: {product.reference}
                    </p>
                  )}
                </div>
              </a>
            </Card>
          );
        })}
      </div>
    </div>
  );
};
